<template lang="pug">
.container.mx-auto.px-6
  .div.w-20.border-t.border-acn-green.mx-auto
  page-menu
  transition(name='quick-fade', appear, mode='out-in') 
    .max-w-xl.mx-auto.text-center(:key='loadedPage.id', v-if='page')
      div(v-show='!loading', v-images-loaded.on='callback')
        .redactor(v-dompurify-html='page.mainText')
        .py-4.my-8.border-t.border-acn-green(v-if='page.title === "Doneer"')
          h2.font-bold.text-xl Donate
          form.my-6(v-if='!sent', @submit.prevent='submit')
            .flex.flex-col.space-y-4
              input.px-4.py-2.rounded-lg(
                type='text',
                v-model='name',
                required,
                placeholder='Naam'
              )
              input.px-4.py-2.rounded-lg(
                type='email',
                v-model='email',
                required,
                placeholder='E-mail adres'
              )
              .flex.space-x-4.justify-between.items-center
                div
                  input#donate_50(
                    type='radio',
                    :value='50',
                    @click='freeDonate = false',
                    v-model='donate'
                  )
                  label.ml-4(for='donate_50') 50,-
                div
                  input#donate_100(
                    type='radio',
                    :value='100',
                    @click='freeDonate = false',
                    v-model='donate'
                  )
                  label.ml-4(for='donate_100') 100,-
                div
                  input#donate_250(
                    type='radio',
                    :value='250',
                    @click='freeDonate = false',
                    v-model='donate'
                  )
                  label.ml-4(for='donate_250') 250,-
                div
                  input.px-4.py-2.rounded-lg.w-32(
                    type='number',
                    v-model='freeDonate',
                    placeholder='Anders',
                    @input='onInput'
                  )

              input.px-4.py-2.rounded-lg(
                type='text',
                v-model='business.name',
                placeholder='Bedrijfsnaam'
              )
              input.px-4.py-2.rounded-lg(
                type='text',
                v-model='business.address.street',
                placeholder='Straat en huisnummer'
              )
              .flex.justify-between.space-x-4
                input.px-4.py-2.rounded-lg(
                  type='text',
                  v-model='business.address.postal',
                  placeholder='Postcode'
                )
                input.px-4.py-2.rounded-lg.flex-grow(
                  type='text',
                  v-model='business.address.city',
                  placeholder='Stad'
                )
              input.px-4.py-2.rounded-lg(
                type='text',
                v-model='business.btwid',
                placeholder='btw-id'
              )
              .flex.justify-end
                a.hover_bg-acn-green-dark.bg-acn-green.px-4.py-2.rounded-lg.text-white(
                  @click='submit'
                ) Stuur mij een factuur
          .py-8(v-else)
            p.mb-4 Bedankt voor je verzoek!
            .flex.justify-center
              a.hover_bg-acn-green-dark.bg-acn-green.px-4.py-2.rounded-lg.text-white(
                @click='sent = false'
              ) Nog een verzoek
</template>

<script>
import share from '@/mixins/share'
import gql from 'graphql-tag'
import { apiQL } from '@/api'
import imagesLoaded from 'vue-images-loaded'

export default {
  name: 'Page',
  directives: {
    imagesLoaded,
  },
  mixins: [share],
  props: {
    slug: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loadedPage: {},
      page: null,
      sent: false,
      name: '',
      email: '',
      donate: 100,
      freeDonate: '',
      business: {
        name: '',
        address: {
          street: '',
          postal: '',
          city: '',
        },
        btwid: '',
      },
    }
  },
  computed: {
    loading() {
      return this.$store.state.loading
    },
    formValid() {
      if (!this.name || !this.email || (!this.freeDonate && !this.donate))
        return false
      return true
    },
  },
  watch: {
    slug(newSlug) {
      this.loadItem(newSlug)
    },
  },
  created() {
    this.$store.commit('loading', true)
    this.loadItem()
  },
  mounted() {
    document.body.className = 'bg-acn-green-light'
  },
  methods: {
    callback(instance, img) {
      this.loadedPage = this.page
      this.$store.commit('loading', false)
    },
    onInput($event) {
      this.freeDonate = $event.target.value || ''
      if (this.freeDonate) this.donate = false
      else this.donate = 100
    },
    submit() {
      if (!this.formValid) return
      const str = `Ik wil graag doneren aan Act Circular Now.
Naam: ${this.name},
Email: ${this.email}
Donatie: ${this.donate || this.freeDonate || 'Geen bedrag gekozen.'}

Bedrijf: ${this.business.name}
        ${this.business.address.street}
        ${this.business.address.postal}
        ${this.business.address.city}
        ${this.business.btwid}`
      this.donateMail(str)
      this.sent = true
    },
    async loadItem() {
      this.$store.commit('loading', true)

      try {
        const q = gql`
          query($slug: [String]) {
            entry(type: "page", slug: $slug) {
              id
              title
              ... on pages_page_Entry {
                mainText
              }
            }
          }
        `
        const result = await apiQL(q, {
          slug: this.slug,
        })

        const page = result.data.entry

        this.page = page
      } catch (error) {
        this.error = error
      }

      if (this.page && this.page.mainText.includes('img src=')) {
        this.loadedPage = {}
        this.$store.commit('loading', true)
      } else {
        this.loadedPage = this.page
        this.$store.commit('loading', false)
      }
    },
  },
  metaInfo() {
    const title = this.page ? this.page.title : ''
    return {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title,
      meta: [
        {
          vmid: 'og:title',
          content: title,
        },
      ],
    }
  },
}
</script>
